import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { LegacyRouterParamsProvider } from '../../contexts/LegacyRouterParams';
import { useLocation, useParams } from 'react-router-dom';
import useLegacyRouterHooks from './useLegacyRouterHooks';
import { ConfigContext } from 'Components/ConfigProvider/ConfigContext';
import getLegacyParams from 'Helpers/getLegacyParams';
import { getBaseName } from 'Constants/basename';

const LazyUniversalComponent = props => {
    const { component, legacyPath, onEnter, onLeave, onChange, isCSR, asyncComponentLoader } = props;
    const basicParams = useParams();
    const location = useLocation();
    const config = useContext(ConfigContext).get();

    const legacyParams = getLegacyParams(legacyPath, location);

    if (typeof window !== 'undefined') {
        // checking for valid lang from current URL.
        if (getBaseName()) {
            legacyParams.lang = getBaseName()?.slice(1)?.toLowerCase();
        }
        else {
            delete legacyParams.lang;
        }
    }

    const params = { ...basicParams, ...legacyParams };

    useLegacyRouterHooks({
        onEnter,
        onLeave,
        onChange,
        config,
        asyncComponentLoader,
        component,
        legacyPath,
        params,
        location
    });

    if (isCSR && typeof window === 'undefined') {
        return null; // No SSR
    }
    const LazyComponent = component;

    return (
        <LegacyRouterParamsProvider value={ params }>
            <LazyComponent />
        </LegacyRouterParamsProvider>
    );
};

LazyUniversalComponent.propTypes = {
    component: PropTypes.any,
    legacyPath: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    onEnter: PropTypes.func,
    onLeave: PropTypes.func,
    onChange: PropTypes.func,
    isCSR: PropTypes.bool,
    asyncComponentLoader: PropTypes.func
};

export default LazyUniversalComponent;
